import type { CustomerApprovalMethod } from '@/types/estimate';

/**
 * NOT-584 — what a new estimate will actually pre-select as its approval
 * method, given the tenant's estimate settings.
 *
 * The settings DTO fills `defaultApprovalMethod` with SIGNATURE for every
 * tenant that never opened the setting, so a stored SIGNATURE cannot be told
 * apart from "never chose" and can only mean "fall back to the signature
 * toggle". Any other method is a deliberate choice and outranks the toggle:
 * it is what the settings screen promises ("Pre-selected on new estimates"),
 * and the submit path re-derives `signatureRequired` from the picked method
 * anyway.
 *
 * Returns null when nothing is pre-selected. Both the estimate form seed and
 * the settings readout resolve through here so a screen can never claim a
 * method the form does not actually apply — reading the stored value directly
 * reports "Signature" to every tenant that has signatures turned off and has
 * never touched the setting.
 */
export function effectiveApprovalMethod(
  defaultApprovalMethod?: CustomerApprovalMethod | null,
  signatureRequired?: boolean | null,
): CustomerApprovalMethod | null {
  if (defaultApprovalMethod && defaultApprovalMethod !== 'SIGNATURE') {
    return defaultApprovalMethod;
  }
  return signatureRequired ? 'SIGNATURE' : null;
}
